import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { SymbolSearchAPIConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { HealthService } from './api/health.service';
import { SearchService } from './api/search.service';
import { ThreadsV1Service } from './api/threadsV1.service';
import { ThreadsV2Service } from './api/threadsV2.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => SymbolSearchAPIConfiguration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [{ provide: SymbolSearchAPIConfiguration, useFactory: configurationFactory }]
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: ApiModule, @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error(
                'You need to import the HttpClientModule in your AppModule! \n' + 'See also https://github.com/angular/angular/issues/20575'
            );
        }
    }
}
